import { ANNUAL } from '@anm/constants/subscription';
import { Reducer } from 'redux';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { pricingActions } from '../';
import { PricingActions, PricingMetaState } from '../types';

const initialPricingState: PricingMetaState = {
  currentPeriod: ANNUAL
};

const pricingMetaReducer: Reducer<PricingMetaState, PricingActions> = (
  state = initialPricingState,
  action
) => {
  switch (action.type) {
    case getType(pricingActions.updatePricingMeta): {
      const { payload: newMetaProps } = action;

      return {
        ...state,
        ...newMetaProps
      };
    }
    default:
      return state;
  }
};

export default pricingMetaReducer;
